import React from "react";
import { FaShieldAlt, FaShippingFast, FaMoneyCheckAlt, FaGlobe } from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const CommunitySection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <div className="w-full flex justify-center py-24 px-6 bg-gray-50 relative">
      {/* Arka Plan Efekti */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-100 to-gray-50 opacity-30 pointer-events-none"></div>

      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="max-w-6xl w-full bg-white rounded-3xl p-12 flex flex-col items-center text-center shadow-xl relative z-10"
      >
        {/* Ana Başlık ve Açıklamalar */}
        <motion.span
          initial={{ opacity: 0, scale: 0.8 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="bg-black text-white text-xs font-semibold px-4 py-1 rounded-full shadow-md"
        >
          PLATFORMUMUZU KEŞFEDİN
        </motion.span>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="text-4xl font-extrabold text-gray-900 mt-5 leading-snug"
        >
          Güvenilir ve Hızlı Alım-Satım Deneyimi
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="text-gray-600 text-lg mt-4 leading-relaxed max-w-2xl"
        >
          Kullanmadığınız cihazları en iyi fiyatla alıp satın. Güvenli işlem süreçleri ile sorunsuz ve şeffaf bir deneyim yaşayın.
        </motion.p>

        {/* Öne Çıkan Özellikler - Bento Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-12 w-full max-w-5xl">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              delay={index * 0.2}
              inView={inView}
              size={index === 0 || index === 3 ? "col-span-2" : "col-span-1"}
            />
          ))}
        </div>

        {/* Call to Action */}
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-12 bg-black text-white px-6 py-3 rounded-lg text-lg font-semibold flex items-center gap-3 hover:bg-gray-800 transition-all shadow-md"
        >
          Hemen Satışa Başla <FiArrowRight />
        </motion.button>
      </motion.div>
    </div>
  );
};

// Özellik Kartları İçin Bileşen
const FeatureCard = ({ icon, title, description, delay, inView, size }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ delay, duration: 0.6, ease: "easeOut" }}
      className={`flex flex-col justify-between p-6 bg-gray-900 text-white rounded-2xl shadow-lg hover:shadow-2xl transition-all ${size}`}
    >
      <div className="flex items-center gap-4">
        <div className="p-4 bg-gray-800 rounded-full">{icon}</div>
        <h3 className="text-xl font-bold">{title}</h3>
      </div>
      <p className="text-sm text-gray-300 mt-3">{description}</p>
    </motion.div>
  );
};

// Öne Çıkan Özellikler
const features = [
  {
    icon: <FaShieldAlt className="text-white text-3xl" />,
    title: "Güvenli İşlem",
    description: "Tüm işlemleriniz şifrelenmiş ve korunmaktadır. Güvenliğiniz bizim için önceliktir.",
  },
  {
    icon: <FaShippingFast className="text-white text-3xl" />,
    title: "Ücretsiz Kargo",
    description: "Cihazınızı ücretsiz kargo seçeneğiyle gönderin. Tüm masrafları biz karşılıyoruz.",
  },
  {
    icon: <FaMoneyCheckAlt className="text-white text-3xl" />,
    title: "En İyi Fiyat",
    description: "Cihazınızın en iyi fiyatla satılması için piyasa analizleri yapıyoruz.",
  },
  {
    icon: <FaGlobe className="text-white text-3xl" />,
    title: "Geniş Kullanıcı Ağı",
    description: "Binlerce kullanıcıya erişim sağlayarak güvenilir bir satış deneyimi yaşayın.",
  },
];

export default CommunitySection;
